import { Pipe, PipeTransform } from '@angular/core';
import { PrinterType } from '../services/printertype.enum'

@Pipe({
  name: 'printerType'
})
export class PrinterTypePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    switch (value) {
      case PrinterType[PrinterType.InvoicePrinter]:
        return "電子發票機"
      case PrinterType[PrinterType.ThermalPrinter]:
        return "熱感式出單機"
      case PrinterType[PrinterType.LabelPrinter]:
        return "標籤機"
      default:
        return "未知"
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/printer-type.pipe.ts